export default "__VITE_ASSET__CAuehwJ3__"